import React from 'react'
import type { Profile } from '../user/Profile'
import { IconButton } from './IconButton'
import classNames from 'classnames'
import { CenteredMessage } from '../../../shared/webcomponents/react-wrappers/CenteredMessage'
import type { KnownUnit } from '../unit/unit'
import { Translations } from '../../../shared/i18n/Translations'

interface ListProps {
    experts: Profile[]
    collaborators: Profile[]
    onExpertClick?: (userId: number) => void
    reportSubject?: KnownUnit
}

export function ExpertsAndCollaboratorsList(props: ListProps) {
    const { experts, collaborators, onExpertClick } = props

    // Render an empty state if there are no experts or collaborators
    if (experts.length === 0 && collaborators.length === 0) {
        const message = Translations.t('appcore:ExpertsList.noExperts', { name: props.reportSubject?.name })
        return (
            <div className="AppCore__ExpertsList__empty">
                <CenteredMessage message={message} iconName="empty-box" />
            </div>
        )
    }

    return (
        <ul className="AppCore__ExpertsList">
            {experts.length > 0 && (
                <li key="subheading-experts" className="AppCore__ExpertsList-GroupHeading">
                    {Translations.t('appcore:ExpertsList.experts')}
                </li>
            )}
            {experts.map((expert) => (
                <li key={'expert-' + expert.userId} className="AppCore__ExpertsList-Item">
                    <Expert user={expert} onExpertClick={onExpertClick} />
                </li>
            ))}
            {collaborators.length > 0 && (
                <li key="subheading-collaborators" className="AppCore__ExpertsList-GroupHeading">
                    {Translations.t('appcore:ExpertsList.collaborators')}
                </li>
            )}
            {collaborators.map((expert) => (
                <li key={'collab-' + expert.userId} className="AppCore__ExpertsList-Item">
                    <Expert user={expert} onExpertClick={onExpertClick} />
                </li>
            ))}
        </ul>
    )
}

interface ExpertProps {
    user: Profile
    onExpertClick?: (userId: number) => void
}

function Expert(props: ExpertProps) {
    const { user, onExpertClick } = props
    const clickable = Boolean(onExpertClick)

    return (
        <div
            className={classNames('AppCore__Expert-wrapper', { 'AppCore__Expert-wrapper--Clickable': clickable })}
            onClick={() => onExpertClick(user.userId)}
        >
            <div className="AppCore__Expert">
                <zaptic-profile-circle
                    name={user.name}
                    color={user.profileCircleColor}
                    profile-image-url={user.profileImageUrl}
                />
                <div className="AppCore__Expert_NameAndTitle">
                    <span className="AppCore__Expert_UserName">{user.name}</span>
                    <span className="AppCore__Expert_UserJobTitle">{user.jobTitle}</span>
                </div>
            </div>
            {onExpertClick && <IconButton border={false} iconName="arrow-right" size="small" />}
        </div>
    )
}
